module.exports = __webpack_public_path__ + "static/media/inventory.2d495e1d.jpg";